import React from 'react';
import { Field, Form, Inline } from '~/components';
import { useFeatures } from '~/hooks';
import SettingsFormSection from '../../SettingsFormSection';

export default function TimeTrackingRules({ formik }) {
  const features = useFeatures();
  const { useRoles } = formik.values;

  return (
    <SettingsFormSection title="Time Tracking Rules">
      <Form.Control>
        <Field.Checkbox label="Every time entry must have notes" name="requireNotes" />
      </Form.Control>

      <Form.Control>
        <Field.Checkbox label="Every time entry must be associated with a task" name="requireTimeEntryTask" />
      </Form.Control>

      {useRoles && (
        <Form.Control>
          <Field.Checkbox label="Members can only track time to assigned roles" name="trackTimeToAssignedRoles" />
        </Form.Control>
      )}

      {features.allocations && (
        <Form.Control>
          <Field.Checkbox
            label="Members can only track time on days where they are allocated"
            name="restrictTimeToAllocatedDays"
          />
        </Form.Control>
      )}

      <Form.Control>
        <Field.Checkbox label="Time cannot be tracked on a weekend" name="forbidTimeOnWeekends" />
      </Form.Control>

      <Form.Control>
        <Field.Checkbox label="Time cannot be tracked on a holiday" name="forbidTimeOnHolidays" />
      </Form.Control>

      <Form.Control>
        <Inline>
          <Field.Checkbox name="capMaxMemberHoursPerMonth" label="Each member can track no more than" />
          <Field.SingleSelect
            name="maxMemberHoursPerMonth"
            materialPlaceholder={false}
            disabled={!formik.values.capMaxMemberHoursPerMonth}
            style={{ width: '6rem', margin: '0 0.5rem', textAlign: 'right' }}>
            {[...Array(200).keys()].map((_, idx) => (
              <option key={idx} value={idx + 1}>
                {idx + 1}
              </option>
            ))}
          </Field.SingleSelect>
          <span>hours in a month</span>
        </Inline>
      </Form.Control>

      <Form.Control>
        <Inline>
          <Field.Checkbox name="capMaxMemberHoursPerWeek" label="Each member can track no more than" />
          <Field.SingleSelect
            name="maxMemberHoursPerWeek"
            materialPlaceholder={false}
            disabled={!formik.values.capMaxMemberHoursPerWeek}
            style={{ width: '6rem', margin: '0 0.5rem', textAlign: 'right' }}>
            {[...Array(60).keys()].map((_, idx) => (
              <option key={idx} value={idx + 1}>
                {idx + 1}
              </option>
            ))}
          </Field.SingleSelect>
          <span>hours in a week</span>
        </Inline>
      </Form.Control>

      <Form.Control>
        <Inline>
          <Field.Checkbox name="capMaxMemberHoursPerDay" label="Each member can track no more than" />
          <Field.SingleSelect
            name="maxMemberHoursPerDay"
            materialPlaceholder={false}
            disabled={!formik.values.capMaxMemberHoursPerDay}
            style={{ width: '6rem', margin: '0 0.5rem', textAlign: 'right' }}>
            {[...Array(12).keys()].map((_, idx) => (
              <option key={idx} value={idx + 1}>
                {idx + 1}
              </option>
            ))}
          </Field.SingleSelect>
          <span>hours in a day</span>
        </Inline>
      </Form.Control>
    </SettingsFormSection>
  );
}
